import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Panel } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faAngleDoubleLeft, faEye, faSpinner } from '@fortawesome/pro-solid-svg-icons';

export default class Card extends React.Component {
  static propTypes = {
    card: PropTypes.shape({
      id: PropTypes.number,
      visibleToClient: PropTypes.bool.isRequired
    }).isRequired,
    children: PropTypes.node,
    connectDragPreview: PropTypes.func,
    connectDragSource: PropTypes.func,
    draggable: PropTypes.bool,
    fullScreen: PropTypes.bool,
    header: PropTypes.node,
    loading: PropTypes.bool,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    onSetAsActive: PropTypes.func,
    onVisibilityChanged: PropTypes.func
  }

  visibilityChanged = (e) => {
    this.props.onVisibilityChanged(this.props.card.id, e.target.checked);
  }

  setCardAsActive = (e) => {
    e.preventDefault();
    this.props.onSetAsActive(this.props.card);
  }

  unsetCardAsActive = (e) => {
    e.preventDefault();
    this.props.onSetAsActive(null);
  }

  renderBackLink() {
    return (
      <div className="back-to-summary">
        <a href="#" name="unset-card-as-active" onClick={this.unsetCardAsActive}>
          <FontAwesomeIcon className="right-buffer-md" icon={faAngleDoubleLeft} />
          Back to Client Report Summary
        </a>
      </div>
    );
  }

  renderShowMoreLink() {
    return (
      <a
        className="expand-card btn-link"
        href="#"
        name="set-card-as-active"
        onClick={this.setCardAsActive}
      >
        See more
        <FontAwesomeIcon className="ml-2" icon={faChevronDown} />
      </a>
    );
  }

  renderBody() {
    if (this.props.loading) return <FontAwesomeIcon className="my-5 center-block" icon={faSpinner} size="2x" spin />;

    return <Panel.Body className="report-panel">{this.props.children}</Panel.Body>;
  }

  renderTitle() {
    const { draggable, title, connectDragSource } = this.props;

    const titleDiv = (
      <div className={`${draggable ? 'cursor-move' : ''}`}>
        <h2 className="mt-0 mb-1">{title}</h2>
      </div>
    );

    return draggable ? connectDragSource(titleDiv) : titleDiv;
  }

  renderHeader() {
    const { card, fullScreen, header, connectDragPreview, draggable, subtitle, onVisibilityChanged } = this.props;
    const headerDiv = (
      <Panel.Heading className="pb-0 pt-3 card-panel-header">
        {fullScreen && this.renderBackLink()}
        <div className="card-header">
          {this.renderTitle()}

          {!fullScreen && onVisibilityChanged && (
            <div className="display-checkbox text-muted text-nowrap">
              <FontAwesomeIcon className="visible-xs mt-1" icon={faEye} />
              <span className="hidden-xs mt-1">Visible to client</span>
              <Checkbox
                checked={card.visibleToClient}
                className="my-0"
                name="toggleCardVisiblity"
                onChange={this.visibilityChanged}
              />
            </div>
          )}

          {fullScreen && <div className="header-right">{header}</div>}
        </div>

        <p className="mb-0 text-muted">{subtitle}</p>
      </Panel.Heading>
    );

    return draggable ? connectDragPreview(<div>{headerDiv}</div>) : headerDiv;
  }

  render() {
    const { fullScreen, onSetAsActive } = this.props;

    return (
      <Panel
        className={`report-tab report-details ${fullScreen ? '' : 'preview-panel'}`}
        name="expanded-report-panel"
      >
        {this.renderHeader()}
        {this.renderBody()}
        {onSetAsActive && !fullScreen && this.renderShowMoreLink()}
      </Panel>
    );
  }
}
